/* eslint-disable no-undef */
import React from 'react';

import { removeProspectIdFromStorage, useInitializeProspect } from './useInitializeProspect';

type Props = { children: React.ReactNode; storage: Storage };
const prospectContext = React.createContext<string | undefined>(undefined);

/** Make sure prospectId is in sessionStorage. Update prospectId if provided by url `?prospectId=${yourProspectId}`  */
function ProspectProvider({ children, storage }: Props): JSX.Element {
  const prospectId = useInitializeProspect(storage);

  return <prospectContext.Provider value={prospectId || ''}>{prospectId && children}</prospectContext.Provider>;
}

function useProspect() {
  const context = React.useContext(prospectContext);
  if (context === undefined) {
    throw new Error('useProspect must be used within a ProspectProvider');
  }
  return context;
}

export { ProspectProvider, useProspect, removeProspectIdFromStorage };
